// Marca visual de "esto es mock / sin backend": marco punteado ámbar + chip en la esquina.
// NO bloquea la interacción (no es un velo): los children siguen operables para demos.
//
// Patrón (ver useSystemParams como ejemplo): la señal `active` viene del hook de datos del
// dominio (`isMock`), NO de acordarse de quitar el wrapper — al conectar el backend el hook
// devuelve isMock: false y el sello se apaga solo. Sirve para pantallas completas o secciones
// parciales (envolver solo la card/tabla que siga en mock). Inventario: grep de `<MockBoundary`
// y de archivos `*.mock.ts`.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function MockBoundary({
    active = true,
    label = 'Mock · sin backend',
    className,
    children,
}: {
    /** Conectar al `isMock` del hook de datos; en `false` solo queda el div de layout. */
    active?: boolean;
    label?: string;
    className?: string;
    children: ReactNode;
}) {
    // Siempre renderiza el div (aunque esté inactivo) para no romper el layout del consumidor
    // que le pasa sus clases de estructura via className. La marca es una franja EN FLUJO
    // (primer hijo), nunca superpuesta al contenido.
    return (
        <div
            className={cn(
                'relative',
                active && 'outline-dashed outline-1 -outline-offset-1 outline-warning/60',
                className,
            )}
        >
            {active ? (
                <div className="flex flex-none items-center justify-end border-b border-dashed border-warning/40 bg-warning/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide text-warning">
                    {label}
                </div>
            ) : null}
            {children}
        </div>
    );
}
